import React, { Fragment } from "react";
import Helmet from "react-helmet";
import Link from "gatsby-link";
import Header from "../../components/Header";
import TourDisplay from "../../components/TourDisplay/TourDisplay";
import hero from "../../images/escorted-tours__hero.jpg";

import mcxTours from "../../mcxTours";

import img01 from "../../images/escorted_tours-1.jpg";
import img02 from "../../images/escorted_tours-2.jpg";
import img03 from "../../images/escorted_tours-3.jpg";
import img04 from "../../images/escorted_tours-4.jpg";
import img05 from "../../images/escorted_tours-5.jpg";
import img06 from "../../images/escorted_tours-6.jpg";

const Page = () => (
  <Fragment>
    <Helmet
      title="Escorted Tours | What We Offer"
      // meta={[{ name: 'description', content: '' }]}
    />
    <Header hero={hero}>
      <h1 className="t-hero">Escorted Tours</h1>
    </Header>
    <main id="content">
      <div className="c-golden t-context--light">
        <div className="c-golden__images c-golden__short min-laptop">
          <img
            src={img01}
            alt=""
            style={{ width: "50%", height: "100%" }}
          />
          <img
            src={img02}
            alt=""
            style={{ width: "50%", height: "50%" }}
          />
          <img
            src={img03}
            alt=""
            style={{ width: "50%", height: "50%" }}
          />
        </div>
        <div className="c-golden__content c-golden__wide">
          <ul className="c-breadcrumbs mb30">
            <li>
              <Link to="/">Home</Link>
            </li>
            <li>
              <Link to="/what-we-offer">What We Offer</Link>
            </li>
            <li>
              <Link
                to="/what-we-offer/escorted-tours"
                activeClassName="is-active"
              >
                Escorted Tours
              </Link>
            </li>
          </ul>
          <div className="c-golden__text">
            <div className="c-golden__text-col">
              <h1 className="t-h1">Sit back relax and enjoy</h1>
              <p className="t-p t-p-light mt30">
              What better way to explore America than by escorted motor coach, 
              allowing you to sit back relax and enjoy the breathtaking scenery 
              while learning about the history and culture of the destination 
              from your expert Tour Director, all while making new friends with 
              fellow travelers along the way. ATI continues to deliver the most 
              extensive set of North American escorted programs in the industry, 
              discovering new destinations and finding the ideal tour selection 
              for both first-time as well as repeat visitors.
              </p>
              <p className="t-p t-p-light mt30">
                Core to the success of our escorted tour program is the excellence 
                of our industry leading Tour Directors, who are trained and employed 
                by ATI to deliver an enjoyable, educational, and memorable experience 
                to our tour passengers.
              </p>
            </div>
          </div>
        </div>
      </div>
      <TourDisplay
        items={mcxTours}
        images={[img04, img05, img06]}
        text="Escorted Tour Routes:"
      />
    </main>
  </Fragment>
);

export default Page;



// WEBPACK FOOTER //
// ./src/pages/what-we-offer/escorted-tours.js